// Bag drawer + add-to-bag flight. Defined before DOMContentLoaded so section scripts (set builder,
// teaware, finder) can call window.SaintchaBag.added() after their own successful /cart/add.js.
// The drawer markup is sections/saintcha-cart-drawer.liquid, refreshed with the Section Rendering API,
// so every price and discount shown is Shopify's. If anything fails the shopper goes to /cart as before.
(()=>{
  const SECTION='saintcha-cart-drawer';
  const rootPath=()=>window.Shopify?.routes?.root||'/';
  const drawer=()=>document.querySelector('[data-bag-drawer]');
  const opener=()=>document.querySelector('[data-bag-open]');
  const cartPage=()=>document.querySelector('[data-bag-page]');
  const isOpen=()=>{const node=drawer();return !!node&&!node.hidden;};
  let lastFocus=null;
  const setCount=count=>{if(count===undefined||count===null||count==='')return;document.querySelectorAll('.demo-count').forEach(node=>{node.textContent=String(count);});};
  // Demo bumpCount(): the Bag count pops after an add (not after a stepper change).
  const bump=()=>{document.querySelectorAll('.demo-count').forEach(node=>{node.classList.remove('bag-pop');void node.offsetWidth;node.classList.add('bag-pop');});};
  // Demo toast(): bottom-left status line, removed after 2.7s.
  const toast=message=>{if(!message)return;const node=document.createElement('div');node.className='bag-toast';node.setAttribute('role','status');node.textContent=message;document.body.appendChild(node);window.setTimeout(()=>node.remove(),2700);};
  // Restart a CSS animation on an element that stays in the DOM.
  const replay=nodes=>nodes.forEach(node=>{if(!node)return;node.style.animation='none';void node.offsetWidth;node.style.animation='';});
  const focusable=panel=>[...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(node=>node.offsetParent!==null);
  const open=()=>{
    const node=drawer();if(!node)return false;
    if(node.hidden){
      lastFocus=document.activeElement;
      node.hidden=false;
      document.documentElement.classList.add('bag-drawer-open');
      opener()?.setAttribute('aria-expanded','true');
      node.querySelector('[data-bag-panel]')?.focus({preventScroll:true});
    }
    return true;
  };
  const close=()=>{
    const node=drawer();if(!node||node.hidden)return;
    node.hidden=true;
    document.documentElement.classList.remove('bag-drawer-open');
    opener()?.setAttribute('aria-expanded','false');
    if(lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus({preventScroll:true});
  };
  // Swap the [data-bag-region] parts of a drawer / cart page root with the freshly rendered ones.
  // The express checkout row [data-bag-pay] is kept (Shopify's wallet buttons are not re-created); it is
  // only filled from the fresh render when it rendered empty, and it follows the Check out disabled state.
  const swap=(current,next,{keepLines=false}={})=>{
    if(!current||!next)return false;
    const keptKeys=new Set(keepLines?[...current.querySelectorAll('[data-bag-line]')].map(line=>line.dataset.lineKey):[]);
    const bar=current.querySelector('[data-bag-progress]');
    const fromWidth=bar?bar.style.width:'';
    let changed=false;
    current.querySelectorAll('[data-bag-region]').forEach(region=>{
      const fresh=next.querySelector(`[data-bag-region="${region.dataset.bagRegion}"]`);
      if(fresh&&fresh.innerHTML!==region.innerHTML){region.innerHTML=fresh.innerHTML;changed=true;}
    });
    const pay=current.querySelector('[data-bag-pay]');
    const freshPay=next.querySelector('[data-bag-pay]');
    if(pay&&freshPay){
      if(!pay.children.length&&freshPay.children.length)pay.innerHTML=freshPay.innerHTML;
      if(freshPay.hasAttribute('aria-disabled'))pay.setAttribute('aria-disabled','true');else pay.removeAttribute('aria-disabled');
    }
    current.dataset.bagCount=next.dataset.bagCount||'0';
    current.dataset.bagBlocked=next.dataset.bagBlocked||'false';
    if(keepLines){
      // Demo cart page patches the DOM in place: lines that were already there do not slide in again,
      // and the free-shipping bar animates from its old width (.8s).
      current.querySelectorAll('[data-bag-line]').forEach(line=>{if(keptKeys.has(line.dataset.lineKey))line.classList.add('is-kept');});
      const nextBar=current.querySelector('[data-bag-progress]');
      if(nextBar&&fromWidth&&nextBar.style.width!==fromWidth){const target=nextBar.style.width;nextBar.style.width=fromWidth;void nextBar.offsetWidth;nextBar.style.width=target;}
    }
    return changed;
  };
  const parse=(html,selector)=>typeof html==='string'?new DOMParser().parseFromString(html,'text/html').querySelector(selector):null;
  // Section Rendering refresh of the drawer (and, on /cart, of the cart page section in the same request).
  // replay: the demo re-renders the whole overlay after a stepper change or an upsell add, so the scrim
  // fades (.35s), the panel slides (.55s) and the lines slide in (.5s) again.
  const refresh=async({replay:replayDrawer=false}={})=>{
    const page=cartPage();
    const pageId=page?.dataset.sectionId;
    const sections=[SECTION].concat(pageId?[pageId]:[]).join(',');
    const base=page?`${rootPath()}cart`:rootPath();
    const response=await fetch(`${base}?sections=${encodeURIComponent(sections)}`,{cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Bag refresh failed');
    const data=await response.json();
    const next=parse(data&&data[SECTION],'[data-bag-drawer]');
    const current=drawer();
    if(!next||!current||!next.querySelector('[data-bag-panel]'))throw new Error('Bag refresh failed');
    swap(current,next);
    if(replayDrawer&&!current.hidden){
      replay([current.querySelector('.bag-drawer__scrim'),current.querySelector('[data-bag-panel]')]);
      current.querySelectorAll('[data-bag-line]').forEach(line=>replay([line]));
    }
    if(page&&pageId){
      const nextPage=parse(data[pageId],'[data-bag-page]');
      if(nextPage)swap(page,nextPage,{keepLines:true});
    }
    setCount(next.dataset.bagCount);
  };
  // The pack photo of what was just added flies from the button to the Bag count (demo: CM 9-30).
  const fly=(source,image)=>new Promise(resolve=>{
    const target=opener()?.querySelector('.demo-count')||opener();
    const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!source||!target||!image||reduce)return resolve();
    const from=source.getBoundingClientRect();
    const to=target.getBoundingClientRect();
    if(!from.width||!to.width)return resolve();
    const x=to.left+to.width/2;const y=to.top+to.height/2;
    const tile=document.createElement('div');
    tile.className='fly cart-pack-fly';tile.setAttribute('aria-hidden','true');
    tile.style.left=`${x}px`;tile.style.top=`${y}px`;
    tile.style.setProperty('--fx',`${from.left+from.width/2-x}px`);
    tile.style.setProperty('--fy',`${from.top+from.height/2-y}px`);
    const img=document.createElement('img');img.src=image;img.alt='';img.width=50;img.height=62;
    tile.appendChild(img);document.body.appendChild(tile);
    let done=false;
    const finish=()=>{if(done)return;done=true;tile.remove();resolve();};
    tile.addEventListener('animationend',finish);
    window.setTimeout(finish,1000);
  });
  const goToCart=()=>{window.location.assign(`${rootPath()}cart`);};
  // Cumulative limit. Shopify can accept an add over the shippable stock (it counts every location at
  // add time), so every theme add first reads /cart.js and caps the request at
  // limit - quantity of that variant already in the bag (all lines, set-group lines included).
  // The limit is always the Liquid-rendered one (saintcha-variant-limit / data-variant-limits / data-max).
  const LIMIT_MESSAGE='You already have the maximum available in your bag.';
  const readCart=async()=>{
    const response=await fetch(`${rootPath()}cart.js`,{cache:'no-store',headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Cart unavailable');
    return response.json();
  };
  const quantityInCart=(cart,variantId)=>(cart&&cart.items||[]).reduce((sum,item)=>sum+(String(item.variant_id??item.id)===String(variantId)?Number(item.quantity)||0:0),0);
  const capQuantity=async(variantId,requested,limit)=>{
    const wanted=Math.max(1,Number.parseInt(requested,10)||1);
    const max=limit===undefined||limit===null||limit===''?NaN:Number(limit);
    if(!Number.isFinite(max))return {allowed:wanted,requested:wanted,inCart:0,limit:null};
    let inCart=0;
    // If /cart.js cannot be read, still never ask for more than the limit itself.
    try{inCart=quantityInCart(await readCart(),variantId);}catch(error){inCart=0;}
    return {allowed:Math.max(0,Math.min(wanted,max-inCart)),requested:wanted,inCart,limit:max};
  };
  const partialMessage=allowed=>`Only ${allowed} more could be added. Your bag now has the maximum available.`;
  const notice=(anchor,text)=>{
    if(!anchor)return null;
    // In the home hero label strip the message gets its own full-width row, so the strip keeps its layout.
    const strip=anchor.closest('.vit-label');
    let node=strip?strip.querySelector(':scope > [data-bag-error]'):anchor.parentElement?.querySelector(':scope > [data-bag-error]');
    if(!text){if(node)node.textContent='';return node;}
    if(!node){node=document.createElement('p');node.className='product-form__status';node.setAttribute('role','status');node.dataset.bagError='';if(strip){node.classList.add('vit-label__status');strip.appendChild(node);}else{anchor.after(node);}}
    node.textContent=text;
    return node;
  };
  const showFull=async()=>{try{await refresh();}catch(error){}open();};
  // After a successful /cart/add.js (demo addToCart / addMany): the pack flies to the Bag count while the
  // drawer is refreshed, then the count pops and the drawer opens. stay (demo data-stay, the upsell):
  // the drawer is not opened (it is re-rendered if it is open) and the demo toast says what was added.
  const added=async({source,image,stay=false,message=''}={})=>{
    if(!drawer()||!window.fetch||!window.DOMParser){goToCart();return;}
    const flight=fly(source,image);
    const refreshed=await refresh({replay:stay}).then(()=>true,()=>false);
    if(!refreshed){goToCart();return;}
    bump();
    if(stay){toast(message);await flight;return;}
    open();
  };
  // Bag line stepper (demo setQty): the new quantity is clamped to the line limit, + is disabled at the
  // limit, 0 removes the line. Posts /cart/change.js by line key, then refreshes the drawer (and the cart
  // page) with the demo re-render. Without JS the same buttons post /cart/change (line + quantity).
  const step=async(form,delta)=>{
    if(form.getAttribute('aria-busy')==='true')return;
    const quantity=Number(form.dataset.lineQuantity)||0;
    const max=form.dataset.lineMax===undefined||form.dataset.lineMax===''?Infinity:Number(form.dataset.lineMax);
    const nextQuantity=Math.max(0,Math.min(max,quantity+delta));
    if(nextQuantity===quantity)return;
    form.setAttribute('aria-busy','true');
    form.querySelectorAll('button').forEach(button=>{button.disabled=true;});
    try{
      const response=await fetch(`${rootPath()}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:form.dataset.lineKey,quantity:nextQuantity})});
      if(!response.ok&&response.status!==422)throw new Error('change failed');
      await refresh({replay:true});
    }catch(error){
      goToCart();
    }
  };
  window.SaintchaBag={open,close,refresh,added,capQuantity,quantityInCart,readCart,notice,showFull,toast,bump,step,LIMIT_MESSAGE,partialMessage};

  document.addEventListener('click',event=>{
    const stepper=event.target.closest('[data-bag-step]');
    if(stepper){
      const form=stepper.closest('[data-bag-qty]');
      if(!form||!window.fetch||!window.DOMParser||!drawer())return;
      event.preventDefault();
      if(!stepper.disabled)step(form,Number(stepper.dataset.bagStep)||0);
      return;
    }
    if(event.target.closest('[data-bag-close]')){event.preventDefault();close();return;}
    const link=event.target.closest('[data-bag-open]');
    if(!link||!drawer())return;
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0)return;
    // On the cart page itself the link just reloads /cart.
    if(link.pathname&&link.pathname===window.location.pathname)return;
    event.preventDefault();
    open();
    refresh().catch(()=>{});
  });
  document.addEventListener('keydown',event=>{
    const node=drawer();
    if(!node||node.hidden)return;
    if(event.key==='Escape'){close();return;}
    if(event.key!=='Tab')return;
    const panel=node.querySelector('[data-bag-panel]');
    const items=panel?focusable(panel):[];
    if(!items.length){event.preventDefault();return;}
    const first=items[0];const last=items[items.length-1];
    if(event.shiftKey&&(document.activeElement===first||document.activeElement===panel)){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });

  // Quick-add forms (home hero, archive and shelf cards). Forms with their own handler (product page,
  // teaware) call preventDefault first and are skipped. Without JS these forms post to /cart/add.
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(event.defaultPrevented||!(form instanceof HTMLFormElement))return;
    const action=(form.getAttribute('action')||'').split('?')[0];
    if(!/\/cart\/add(\.js)?$/.test(action))return;
    if(!window.fetch||!window.FormData||!drawer())return;
    event.preventDefault();
    if(form.dataset.bagBusy==='true')return;
    form.dataset.bagBusy='true';
    const submitter=event.submitter||form.querySelector('[type="submit"]');
    submitter?.classList.add('is-loading');submitter?.setAttribute('aria-busy','true');
    const cardImage=form.closest('.demo-card')?.querySelector('.demo-card__primary');
    const image=submitter?.dataset.bagImage||cardImage?.currentSrc||cardImage?.src||'';
    notice(form,'');
    try{
      const body=new FormData(form);
      const cap=await capQuantity(body.get('id'),body.get('quantity'),submitter?.dataset.bagMax);
      if(cap.allowed<1){notice(form,LIMIT_MESSAGE);await showFull();return;}
      body.set('quantity',String(cap.allowed));
      const response=await fetch(`${rootPath()}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body});
      if(!response.ok){
        const error=await response.json().catch(()=>({}));
        notice(form,typeof error.description==='string'?error.description:'Could not add this item. Please try again.');
        return;
      }
      if(cap.allowed<cap.requested)notice(form,partialMessage(cap.allowed));
      // Demo confirmation: the card button reads "Add another", the hero button "Added".
      if(submitter?.dataset.addedLabel)submitter.textContent=submitter.dataset.addedLabel;
      await added({source:submitter||form,image,stay:form.hasAttribute('data-bag-stay'),message:form.dataset.bagToast||''});
    }catch(error){
      goToCart();
    }finally{
      delete form.dataset.bagBusy;
      submitter?.classList.remove('is-loading');submitter?.removeAttribute('aria-busy');
    }
  });
})();

// Best-by month (snippets/saintcha-best-by.liquid): from the base month (YYYY-MM), add 6 months until the
// month is the current month or later. Re-computed here so a cached product page never shows a past month.
window.SaintchaBestBy=(()=>{
  const MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const roll=(base,now=new Date())=>{
    const match=/^(\d{4})-(\d{1,2})/.exec(String(base||''));
    if(!match)return null;
    let index=Number(match[1])*12+Number(match[2])-1;
    if(Number(match[2])<1||Number(match[2])>12)return null;
    const current=now.getFullYear()*12+now.getMonth();
    if(index<current)index+=Math.ceil((current-index)/6)*6;
    return {year:Math.floor(index/12),month:index%12};
  };
  const label=(base,now)=>{const result=roll(base,now);return result?`${MONTHS[result.month]} ${result.year}`:'';};
  return {roll,label};
})();

document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-nav]');
  menu?.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');menu.setAttribute('aria-expanded',String(open));});

  const hero=document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(button=>button.addEventListener('click',()=>{
    if(!hero)return;
    const src=button.dataset.src;
    const alt=button.dataset.alt||'';
    hero.src=src;hero.alt=alt;
    document.querySelectorAll('[data-gallery-thumb]').forEach(item=>item.setAttribute('aria-current',String(item===button)));
  }));

  const variantSelect=document.querySelector('[data-variant-select]');
  const variantsElement=document.querySelector('[data-variants-json]');
  if(variantSelect&&variantsElement){
    let variants=[];try{variants=JSON.parse(variantsElement.textContent)}catch{}
    // Per-variant limits are rendered in Liquid (data-variant-limits); product.variants JSON has no inventory_quantity.
    const limits=new Map();
    try{JSON.parse(document.querySelector('[data-variant-limits]')?.textContent||'[]').forEach(item=>limits.set(String(item.id),item));}catch{}
    // Never widen: with no server limit, a tracked deny variant gets 1, anything else 5.
    const maxFor=variant=>{const limit=limits.get(String(variant.id));if(limit&&Number.isFinite(Number(limit.max)))return Math.max(0,Math.min(5,Number(limit.max)));return variant.inventory_management&&variant.inventory_policy==='deny'?1:5;};
    const productForm=variantSelect.closest('form');
    const status=document.querySelector('[data-product-status]');
    const price=document.querySelector('[data-product-price]');
    const add=document.querySelector('[data-add-button]');
    const quantity=document.querySelector('[data-product-quantity]');
    const currency=variantsElement.dataset.currency||'USD';
    const sizeButtons=[...document.querySelectorAll('[data-size-option]')];
    const stepMinus=document.querySelector('[data-qty-step="-1"]');
    const stepPlus=document.querySelector('[data-qty-step="1"]');
    const stockLine=document.querySelector('[data-pdp-status]');
    let facts={};try{facts=JSON.parse(document.querySelector('[data-variant-facts]')?.textContent||'{}')||{};}catch{}
    // Demo money(): "$37", "$37.50" (no trailing .00).
    const format=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,minimumFractionDigits:cents%100===0?0:2,maximumFractionDigits:2}).format(cents/100);
    const currentVariant=()=>variants.find(item=>String(item.id)===variantSelect.value);
    const currentQuantity=()=>Math.max(1,Number.parseInt(quantity?.value,10)||1);
    // "Up to N" next to quantity: same limit as the input max; nothing for a sold-out size (demo DP:1161).
    const limitLabel=document.querySelector('[data-quantity-limit]');
    const setLimitLabel=variant=>{if(!limitLabel)return;const max=variant?maxFor(variant):0;limitLabel.textContent=variant&&variant.available&&max>0?`Up to ${max}`:'';};
    // Demo: the price and the button read price x quantity ("Add to bag · $74" at 2).
    const setTotals=()=>{
      const variant=currentVariant();if(!variant)return;
      const total=format(variant.price*currentQuantity());
      if(price)price.textContent=total;
      if(add){const preorder=Boolean(limits.get(String(variant.id))?.preorder);add.textContent=variant.available?`${preorder&&add.dataset.preorder?add.dataset.preorder:add.dataset.available} · ${total}`:add.dataset.soldOut;}
    };
    const syncSteppers=()=>{
      const variant=currentVariant();
      const max=variant&&variant.available?maxFor(variant):0;
      const value=currentQuantity();
      if(stepMinus)stepMinus.disabled=!max||value<=1;
      if(stepPlus)stepPlus.disabled=!max||value>=max;
    };
    // Status line: "● In stock · Best by Mar 2027" / "◷ Available for pre-order" / "Sold out" (demo pagePDP status).
    const setStockLine=variant=>{
      if(!stockLine||!variant)return;
      const preorder=Boolean(limits.get(String(variant.id))?.preorder);
      const dates=stockLine.dataset.showDates==='true';
      const bestBy=window.SaintchaBestBy?window.SaintchaBestBy.label(stockLine.dataset.bestByBase)||stockLine.dataset.bestBy:stockLine.dataset.bestBy;
      const packed=stockLine.dataset.packed||'';
      let text='Sold out';
      if(variant.available&&preorder)text=`◷ Available for pre-order${dates&&bestBy?` · Best by ${bestBy}`:''}`;
      else if(variant.available)text=`● In stock${dates&&packed?` · Packed ${packed}`:''}${dates&&bestBy?` · Best by ${bestBy}`:''}`;
      stockLine.textContent=text;
      stockLine.classList.toggle('is-sold',!variant.available);
      stockLine.classList.toggle('is-preorder',variant.available&&preorder);
    };
    const update=()=>{
      const variant=currentVariant();
      if(!variant)return;
      // Price a bowl at 2g (demo perBowl), kept in step with the selected size.
      const perBowl=document.querySelector('[data-product-per-bowl]');
      if(perBowl){const grams=Number.parseFloat(String(variant.title||'').toLowerCase().replace(/refill|bag/g,''));perBowl.textContent=grams>0?`${new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(Math.round(variant.price*2/grams)/100)} a bowl`:'';}
      if(add)add.disabled=!variant.available;
      if(quantity){const current=parseInt(quantity.value,10)||1;const max=maxFor(variant);quantity.disabled=!variant.available||max<1;quantity.max=String(Math.max(1,max));quantity.value=String(Math.max(1,Math.min(current,Number(quantity.max))));}
      sizeButtons.forEach(button=>{const on=button.dataset.variantId===String(variant.id);button.classList.toggle('on',on);button.setAttribute('aria-pressed',on?'true':'false');});
      setTotals();syncSteppers();setLimitLabel(variant);setStockLine(variant);
      // Round 8 (N5): facts grid (size, bowls at 2g, per bowl) and gallery caption follow the size.
      const fact=facts[String(variant.id)];
      if(fact){
        [['size','size'],['bowls','bowls'],['per-bowl','perBowl']].forEach(([name,key])=>{
          const row=document.querySelector(`[data-fact="${name}"]`);if(!row)return;
          const value=row.querySelector('[data-fact-value]');if(value)value.textContent=fact[key]||'';
          row.hidden=!fact[key];
        });
      }
      const caption=document.querySelector('[data-gallery-caption]');if(caption)caption.textContent=fact&&fact.caption?fact.caption:`Studio view · ${variant.title}`;
      if(status)status.textContent='';
      if(hero){
        const selectedOption=variantSelect.selectedOptions[0];
        const bagImage=selectedOption?.dataset.bagSrc;
        const variantImage=selectedOption?.dataset.imageSrc;
        if(bagImage){hero.src=bagImage;hero.alt=`${document.querySelector('.product-info h1')?.textContent||''} ${variant.title} bag`;}
        // Studio pack photo (tin on plinth) wins over Shopify variant media, so the hero keeps the exact tin like the demo.
        else if(hero.hasAttribute('data-studio-image')&&hero.dataset.productImageSrc){hero.src=hero.dataset.productImageSrc;hero.alt=hero.dataset.productImageAlt||'';}
        else if(variantImage){hero.src=variantImage;hero.alt=selectedOption.dataset.imageAlt||'';}
        else if(hero.dataset.productImageSrc){hero.src=hero.dataset.productImageSrc;hero.alt=hero.dataset.productImageAlt||'';}
        document.querySelectorAll('[data-gallery-thumb]').forEach(item=>item.setAttribute('aria-current','false'));
      }
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    };
    variantSelect.addEventListener('change',update);
    // Demo: choosing a size (sold-out sizes too) selects it and resets the quantity to 1.
    sizeButtons.forEach(button=>button.addEventListener('click',()=>{
      if(variantSelect.value===button.dataset.variantId)return;
      variantSelect.value=button.dataset.variantId;
      if(quantity)quantity.value='1';
      variantSelect.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    const clampQuantity=()=>{const value=Number.parseInt(quantity.value,10);quantity.value=String(Math.max(1,Math.min(Number.isFinite(value)?value:1,Number(quantity.max)||1)));setTotals();syncSteppers();};
    quantity?.addEventListener('change',clampQuantity);
    [stepMinus,stepPlus].forEach(button=>button?.addEventListener('click',()=>{
      if(!quantity||button.disabled)return;
      quantity.value=String(currentQuantity()+(Number(button.dataset.qtyStep)||0));
      clampQuantity();
    }));
    update();

    // Cart-side guard: Liquid only sees the storefront total, so let Shopify have the last word.
    // On a 422 from /cart/add.js, show Shopify's message and clamp to the number it allows.
    productForm?.addEventListener('submit',async event=>{
      if(!window.fetch||!window.FormData)return;
      event.preventDefault();
      const variant=currentVariant();
      const button=productForm.querySelector('[data-add-button]');
      if(button?.classList.contains('is-loading'))return;
      if(button){button.disabled=true;button.classList.add('is-loading');button.setAttribute('aria-busy','true');}
      const done=()=>{if(button){button.disabled=!(variant&&variant.available);button.classList.remove('is-loading');button.removeAttribute('aria-busy');}};
      if(status)status.textContent='';
      try{
        const root=window.Shopify?.routes?.root||'/';
        const body=new FormData(productForm);
        // Cap at the variant limit minus what is already in the bag (see SaintchaBag.capQuantity).
        let cap=null;
        if(window.SaintchaBag&&variant){
          cap=await window.SaintchaBag.capQuantity(variant.id,body.get('quantity'),maxFor(variant));
          if(cap.allowed<1){
            if(status)status.textContent=window.SaintchaBag.LIMIT_MESSAGE;
            done();
            window.SaintchaBag.showFull();
            return;
          }
          body.set('quantity',String(cap.allowed));
        }
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body});
        if(response.ok){
          done();
          if(status&&cap&&cap.allowed<cap.requested)status.textContent=window.SaintchaBag.partialMessage(cap.allowed);
          // Demo: after an add the PDP quantity goes back to 1.
          if(quantity){quantity.value='1';setTotals();syncSteppers();}
          const option=variantSelect.selectedOptions[0];
          const image=option?.dataset.packSrc||option?.dataset.bagSrc||hero?.dataset.productImageSrc||hero?.src||'';
          if(window.SaintchaBag)window.SaintchaBag.added({source:button,image});else location.href=`${root}cart`;
          return;
        }
        const error=await response.json().catch(()=>({}));
        const message=typeof error.description==='string'?error.description:(error.message||'Could not add this item. Please review the quantity and try again.');
        if(response.status===422&&variant&&quantity){
          const only=/only add (\d+)/i.exec(message);
          const allInCart=/^all \d+ /i.test(message)||/can(?:no|')t add more/i.test(message);
          const limit=limits.get(String(variant.id))||{id:variant.id};
          const previous=Number.isFinite(Number(limit.max))?Number(limit.max):5;
          if(only)limit.max=Math.min(previous,Number(only[1]));
          else if(allInCart)limit.max=0;
          limits.set(String(variant.id),limit);
          const max=maxFor(variant);
          quantity.max=String(Math.max(1,max));
          quantity.value=String(Math.max(1,Math.min(Number.parseInt(quantity.value,10)||1,Number(quantity.max))));
          setLimitLabel(variant);setTotals();syncSteppers();
          if(max<1){done();quantity.disabled=true;if(button)button.disabled=true;if(status)status.textContent=message;return;}
        }
        if(status)status.textContent=message;
        done();
      }catch(error){
        if(status)status.textContent='Could not add this item. Please try again.';
        done();
      }
    });
  }

  // "Reduce to N" on over-limit bag lines: the link works without JS (/cart/change?line=&quantity=);
  // with JS it posts /cart/change.js by line key and refreshes the drawer / cart page (reload as fallback).
  // Delegated, because the lines are re-rendered by the Section Rendering refresh.
  document.addEventListener('click',async event=>{
    const link=event.target.closest('[data-cart-reduce]');
    if(!link||!window.fetch)return;
    event.preventDefault();
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:link.dataset.lineKey,quantity:Number(link.dataset.lineQuantity)||0})});
      if(!response.ok)throw new Error('change failed');
      try{if(!window.SaintchaBag||!document.querySelector('[data-bag-drawer]'))throw new Error('no drawer');await window.SaintchaBag.refresh({replay:true});}
      catch(error){window.location.reload();}
    }catch(error){window.location.assign(link.href);}
  });

  const setForm=document.querySelector('[data-set-form]');
  setForm?.addEventListener('submit',async event=>{
    event.preventDefault();
    const status=setForm.querySelector('[data-set-status]');
    const button=setForm.querySelector('button[type=submit]');
    const items=[...setForm.querySelectorAll('[data-set-quantity]')].map(input=>({id:Number(input.dataset.variantId),quantity:Number(input.value)||0})).filter(item=>item.quantity>0);
    if(!items.length){status.textContent='Choose at least one tin.';return;}
    button.disabled=true;status.textContent='Adding your set…';
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||'Could not add the set. Please review stock and try again.');}
      location.href=`${window.Shopify?.routes?.root||'/'}cart`;
    }catch(error){status.textContent=error.message;button.disabled=false;}
  });
});

// Archive: preparation chips (?use=), house select (navigates between house collections) and sort.
// 2026-10-15: two groups ("In stock now" and "Back soon"), each its own grid, so every sort keeps
// in-stock first. Tiles (refill, Get fitted) are not counted and stay after the cards.
(()=>{
  const init=()=>{
    const root=document.querySelector('[data-archive]');
    const grids=root?[...root.querySelectorAll('[data-archive-grid]')]:[];
    if(!root||!grids.length||root.dataset.archiveReady)return;
    root.dataset.archiveReady='1';
    window.saintchaArchive=true;
    const cards=[...root.querySelectorAll('[data-archive-card]')];
    cards.forEach((card,index)=>{card.dataset.cardIndex=String(index);});
    const tiles=[...root.querySelectorAll('[data-archive-tile]')];
    const isIn=card=>card.dataset.cardAvailable==='true';
    const chips=[...root.querySelectorAll('[data-archive-use]')];
    const houseSelect=root.querySelector('[data-archive-house-select]');
    const sortSelect=root.querySelector('[data-archive-sort]');
    const countNode=root.querySelector('[data-archive-count]');
    const empty=root.querySelector('[data-archive-empty]');
    const emptyIn=root.querySelector('[data-archive-empty-in]');
    const emptyUse=root.querySelector('[data-archive-empty-use]');
    const outGroup=root.querySelector('[data-archive-group="out"]');
    const outCount=root.querySelector('[data-archive-out-count]');
    const setBanner=root.querySelector('[data-archive-set-banner]');
    const house=root.dataset.archiveHouse||'';
    const params=new URLSearchParams(location.search);
    const uses=['latte','usucha','koicha','hojicha'];
    let use=uses.includes(params.get('use'))?params.get('use'):'all';
    const initialSort=params.get('sort_by')||'';
    const usesOf=el=>(el.dataset.cardUses||'').split(' ');
    // Chip labels show how many tins for that use can be bought today.
    chips.forEach(chip=>{
      const u=chip.dataset.archiveUse;
      if(!uses.includes(u)||chip.querySelector('.chip-count'))return;
      const n=cards.filter(card=>isIn(card)&&usesOf(card).includes(u)).length;
      const badge=document.createElement('span');
      badge.className='chip-count';badge.textContent=String(n);
      badge.setAttribute('aria-label',`${n} in stock`);
      chip.appendChild(badge);
    });
    const syncUrl=()=>{
      const next=new URLSearchParams(location.search);
      if(use==='all')next.delete('use');else next.set('use',use);
      const value=sortSelect?.value;
      if(value&&value!=='manual')next.set('sort_by',value);else next.delete('sort_by');
      const query=next.toString();
      history.replaceState(history.state,'',location.pathname+(query?'?'+query:''));
    };
    const apply=()=>{
      let shownIn=0,shownOut=0;
      cards.forEach(card=>{
        const match=use==='all'||usesOf(card).includes(use);
        card.hidden=!match;
        if(match){if(isIn(card))shownIn+=1;else shownOut+=1;}
      });
      tiles.forEach(tile=>{tile.hidden=!(tile.hasAttribute('data-tile-always')||use==='all'||usesOf(tile).includes(use));});
      chips.forEach(chip=>{const on=chip.dataset.archiveUse===use;chip.classList.toggle('is-active',on);chip.classList.toggle('on',on);});
      const forUse=use!=='all'?' for '+use:'';
      if(countNode)countNode.textContent=`${shownIn} in stock${forUse} · ${shownOut} back soon${house?' from '+house:''} · every tin factory-sealed and dated`;
      if(emptyUse)emptyUse.textContent=use!=='all'?`for ${use} `:'';
      if(emptyIn)emptyIn.hidden=shownIn>0||shownIn+shownOut===0;
      if(outGroup)outGroup.hidden=shownOut===0;
      if(outCount)outCount.textContent=String(shownOut);
      if(setBanner)setBanner.hidden=shownIn<2;
      if(empty)empty.hidden=shownIn+shownOut>0;
    };
    const sortCards=()=>{
      const value=sortSelect?.value||'manual';
      const number=(card,key)=>Number(card.dataset[key])||0;
      const compare=(a,b)=>{
        if(value==='price-per-bowl')return (number(a,'cardPerBowl')||Infinity)-(number(b,'cardPerBowl')||Infinity)||number(a,'cardIndex')-number(b,'cardIndex');
        if(value==='price-ascending')return number(a,'cardPrice')-number(b,'cardPrice')||number(a,'cardIndex')-number(b,'cardIndex');
        if(value==='price-descending')return number(b,'cardPrice')-number(a,'cardPrice')||number(a,'cardIndex')-number(b,'cardIndex');
        return number(a,'cardIndex')-number(b,'cardIndex');
      };
      grids.forEach(grid=>{
        const own=[...grid.querySelectorAll(':scope > [data-archive-card]')].sort(compare);
        const anchor=grid.querySelector(':scope > [data-archive-tile], :scope > .archive-empty');
        own.forEach(card=>grid.insertBefore(card,anchor||null));
      });
    };
    chips.forEach(chip=>chip.addEventListener('click',event=>{
      event.preventDefault();
      use=chip.dataset.archiveUse||'all';
      apply();syncUrl();
    }));
    houseSelect?.addEventListener('change',()=>{
      const target=new URL(houseSelect.value,location.origin);
      if(use!=='all')target.searchParams.set('use',use);
      if(sortSelect?.value&&sortSelect.value!=='manual')target.searchParams.set('sort_by',sortSelect.value);
      location.href=target.pathname+target.search;
    });
    sortSelect?.addEventListener('change',()=>{
      // Server order was used for this page load; going back to Recommended after a server sort needs a reload.
      if(sortSelect.value==='manual'&&initialSort&&initialSort!=='manual'&&initialSort!=='price-per-bowl'){
        const next=new URLSearchParams(location.search);next.delete('sort_by');
        location.href=location.pathname+(next.toString()?'?'+next:'');return;
      }
      sortCards();syncUrl();
    });
    if(sortSelect&&initialSort==='price-per-bowl')sortSelect.value='price-per-bowl';
    if(sortSelect&&sortSelect.value==='price-per-bowl')sortCards();
    root.querySelector('[data-archive-clear]')?.addEventListener('click',event=>{
      if(house)return;
      event.preventDefault();use='all';apply();syncUrl();
    });
    apply();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

// Houses shelf: "Explore" scrolls the rail by about one card; at the end it returns to the start.
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-house-explore]');
  if(!button)return;
  const section=button.closest('section')||document;
  const rail=section.querySelector('.house-rail');
  if(!rail)return;
  const card=rail.querySelector('.house-card');
  const step=card?card.getBoundingClientRect().width+16:rail.clientWidth*0.8;
  const atEnd=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;
  rail.scrollTo({left:atEnd?0:rail.scrollLeft+step,behavior:'smooth'});
});
